var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.126,
    height: 20.126,
    viewBox: "0 0 20.126 20.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-left",
    "data-name": "Icon feather-arrow-left",
    transform: "translate(-6.5 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23751",
    "data-name": "Tracciato 23751",
    d: "M25.626,19H7.5a1,1,0,0,1,0-2H25.626a1,1,0,1,1,0,2Z",
    transform: "translate(0 -1.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23752",
    "data-name": "Tracciato 23752",
    d: "M16.563,26.626a1,1,0,0,1-.707-.293L6.793,17.27a1,1,0,0,1,0-1.414l9.063-9.063A1,1,0,0,1,17.27,8.207L8.914,16.563l8.356,8.356a1,1,0,0,1-.707,1.707Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7fb579715a5affb95c7f5980363e18d0.svg";
export { ForwardRef as ReactComponent };